import canvasNodeLoading from '@/app/assets/imgs/canvas-node-loading.gif';
import { cn } from '@/app/utils';

export const LoadingComponent = ({ className }: { className?: string }) => {
  return (
    <div className={cn('flex h-full w-full items-center justify-center bg-[#131212]', className)}>
      <img src={canvasNodeLoading.src} alt="loading" className="h-40 max-h-full w-40 max-w-full object-cover" />
    </div>
  );
};
